import { ContainerPointsResource, containerPointsResource } from '@witkac/kartamiejska-resources';
import { ContainerPoints } from '@witkac/kartamiejska-shared';

import { EntityListModule } from '../entityList.module';

/**
 * Moduł kontenerów na punkty klienta
 *
 * @class ClientContainerPointsModule
 * @extends {EntityModule<ContainerPoints, ContainerPointsResource>}
 */
class ClientContainerPointsModule extends EntityListModule<ContainerPoints, ContainerPointsResource> {}

export default new ClientContainerPointsModule(containerPointsResource);
